"use strict";

exports.__esModule = true;
exports.AdvancedMetricChartElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Time = require("../../Time");
var _Catalogs = require("../../../Catalogs");
var _AdvancedHistoricalMetricChartElement = require("./AdvancedHistoricalMetricChartElement");
var _AdvancedRealTimeMetricChartElement = require("./AdvancedRealTimeMetricChartElement");
var _Device = require("../../Device");
var _downloadDataFromSeries = require("../../Echarts/Series/downloadDataFromSeries");
var _timeFormatters = require("../../../Utils/timeFormatters");
var _Core = require("../../Core");
var _Charts = require("../../Charts");
var _dataItemChartOptions = require("../../Echarts/Series/dataItemChartOptions");
var _dataConverter = require("./dataConverter");
var _yAxisFormatterFactory = require("./yAxisFormatterFactory");
var _echartsEventDictionary = require("../../Echarts/echartsEventDictionary");
var _useUiDesign2 = require("../../Theme/UiDesign/useUiDesign");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var AdvancedMetricChartElement = exports.AdvancedMetricChartElement = function AdvancedMetricChartElement(props) {
  var device = (0, _react.useContext)(_Device.DeviceContext);
  var devices = (0, _react.useContext)(_Device.DeviceListContext);
  var _useContext = (0, _react.useContext)(_Time.TimeContext),
    timezone = _useContext.timezone,
    currentWorkday = _useContext.currentWorkday,
    currentShift = _useContext.currentShift;
  var _useContext2 = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext2.translate;
  var _useUiDesign = (0, _useUiDesign2.useUiDesign)(),
    uiModern = _useUiDesign.modern;
  var timePeriod = (0, _Time.useSelectionContext)();
  var width = props.width,
    height = props.height,
    title = props.title,
    toolbox = props.toolbox,
    statistics = props.statistics,
    visualMap = props.visualMap,
    chartItems = props.chartItems,
    controls = props.controls,
    _props$selectedMetric = props.selectedMetrics,
    selectedMetrics = _props$selectedMetric === void 0 ? [] : _props$selectedMetric;
  var options = {
    title: title,
    toolbox: toolbox,
    statistics: statistics,
    visualMap: visualMap,
    chartItems: chartItems,
    controls: controls,
    selectedMetrics: selectedMetrics
  };
  var selectedDevices = device ? [device] : devices || [];
  var metricNames = selectedMetrics.map(function (sm) {
    return sm.name;
  });
  var echartRef = (0, _react.useRef)({});
  var isCurrent = (0, _Catalogs.canSubscribeToRealtime)(currentWorkday.interval, currentShift.interval, timePeriod.interval);
  var ChartComponent = isCurrent ? _AdvancedRealTimeMetricChartElement.AdvancedRealTimeMetricChartElement : _AdvancedHistoricalMetricChartElement.AdvancedHistoricalMetricChartElement;
  var _downloadCSVData = function downloadCSVData(deviceName, data) {
    return (0, _downloadDataFromSeries.downloadDataFromSeries)(deviceName + "-metrics-" + (0, _timeFormatters.formatToDateOnly)(timePeriod.startPlantTime, timezone) + "-" + (0, _timeFormatters.formatToDateOnly)(timePeriod.endPlantTime, timezone), data, "Metric");
  };
  var unitForFormatter = selectedMetrics.length > 0 ? selectedMetrics[0].units : "";
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "AdvancedMetricChartElement.element"
  }, /*#__PURE__*/_react["default"].createElement(ChartComponent, {
    selectedDevices: selectedDevices,
    metricNames: metricNames
  }, function (data) {
    if (options != null && options.chartItems) {
      return /*#__PURE__*/_react["default"].createElement(_Charts.ReactEChartsLineChart, {
        echartRef: echartRef,
        width: width,
        height: height,
        timezone: timezone,
        options: (0, _dataItemChartOptions.createDataItemEChartProps)({
          series: data,
          device: device,
          dataItems: (0, _dataConverter.convertMetricsToEchartsDataItemsFormat)(selectedMetrics),
          dataItemFieldName: "label",
          yAxisFormatter: (0, _yAxisFormatterFactory.yAxisFormatterFactory)(unitForFormatter),
          options: options,
          timezone: timezone,
          translate: translate,
          downloadCSVData: function downloadCSVData(deviceName, data) {
            return _downloadCSVData(deviceName, data);
          },
          predefinedMaxValue: (0, _yAxisFormatterFactory.yAxisMaxValueFactory)(unitForFormatter),
          uiModern: uiModern
        }),
        onEvents: (0, _echartsEventDictionary.getEventDictForSwitchingBetweenItemAndAxisTriggerForTooltip)(echartRef)
      });
    }
  }));
};